export const contact_method = {
  type: {
    internal: 'Internal',
    external: 'External',
    sip: 'SIP-account'
  },

  label: {
    home: 'Home',
    work: 'Work',
    office: 'Office'
  }
};
